export const register = {
    title: '등록',
    passwordLabel: '비밀번호',
    confirmPassword: '새 비밀번호 입력',
    buttonRegister: '등록하기',
    confirmPasswordLabel: '새 비밀번호 확인',
    policy1: '동의합니다',
    policy2: '약관',
    and: '그리고',
    policy3: '개인 정보 보호 정책.',
    backToLogin: '로그인으로 돌아가기',
    contentAfterRegister:
        '성공적인 등록을 축하합니다! 이메일을 확인하여 계정을 확인하세요. 받은 편지함에 확인 이메일이 보이지 않으면 스팸 폴더를 확인하십시오.',
};
